<template>
  <div class="create-post" v-if="VideoDetails.dialog">
    <v-overlay>
      <div>
        <div class="overlay-content">
          <v-row style="width: 1000px; margin: auto; padding: auto">
            <v-col> </v-col>
            <v-col>
              <div>
                <v-row>
                  <div
                    v-if="showComment == false"
                    class="create-content-dialog"
                  >
                    <div>
                      <v-container>
                        <v-row style="padding: 10px">
                          <v-col cols="1" class="avatar">
                            <v-avatar size="36">
                              <img :src="VideoDetails.logo" />
                            </v-avatar>
                          </v-col>
                          <v-col cols="9">
                            <div class="name">
                              <v-row>
                                <label
                                  style="font-weight: 500; margin-left: 0.6rem"
                                  class="--font"
                                >
                                  {{ VideoDetails.brandName }}
                                </label>
                              </v-row>
                              <v-row style="margin-left: 0rem">
                                <small class="secondary-font lowerText">
                                  Posted
                                  <time-ago
                                    :datetime="VideoDetails.time"
                                    long
                                  ></time-ago>
                                </small>
                              </v-row>
                            </div>
                          </v-col>
                          <v-spacer />
                          <v-col>
                            <!-- <v-icon class="icon"> mdi-dots-vertical</v-icon> -->
                          </v-col>
                        </v-row>
                      </v-container>
                    </div>
                    <div style="margin-left: 0.8rem; margin-bottom: 0rem">
                      <!-- <p
                    style="
                      font-size: 14px;
                      font-weight: 500;
                      text-align: left;
                      margin-bottom: 1rem;
                    "
                  >
                    {{ VideoDetails.description }}
                  </p> -->
                      <p
                        style="
                          font-size: 14px;
                          font-weight: 400;
                          margin-bottom: 0rem;
                          text-align: left;
                          word-wrap: break-word;
                          padding: 0.2rem;
                        "
                        class="--font"
                      >
                        {{ VideoDetails.description }}
                      </p>
                    </div>

                    <div
                      style="padding: 2px; margin-top: 0.6rem"
                      v-if="VideoDetails.video.clip " 
                    >

                      <video width="100%" controls style="max-height: 300px"    preload="metadata">
                        <source :src="VideoDetails.video.clip.mp4_src_url" />
                      </video>
                    </div>
                    <div v-else>
                      <div>
                        <img
                          style="border-radius: 8px; object-fit: contain"
                          width="100%"
                          height="200px"
                          :src="VideoDetails.video.image.original"
                        />
                      </div>
                    </div>

                    <div
                      style="
                        margin: 1rem;
                        margin-top: 1.2rem;
                        margin-bottom: 1.8rem;
                        margin-left: 1rem;
                      "
                    >
                      <v-row style="margin-left: 1px">
                        <small class="bold" style="color: #a5afa9">
                          <!-- {{ VideoDetails.views }} Views . -->
                          {{ VideoDetails.likes }} Likes .
                          {{ VideoDetails.comments }} Comments .

                          {{ VideoDetails.shares }} Shares</small
                        >
                      </v-row>
                    </div>
                    <v-row class="py-4">
                      <button
                        @click="showComment = true"
                        class="--green draft mt-4 pointer"
                      >
                        View and manage comments
                      </button>
                    </v-row>
                    <div v-if="false">
                      <v-row>
                        <v-col cols="1">
                          <button style="background-color: #f5f9f5">
                            <v-icon style="padding: 8px" color="#B8C3B8">
                              mdi-thumb-up</v-icon
                            >
                          </button>
                        </v-col>

                        <v-col cols="11" class="flex">
                          <v-text-field
                            dense
                            outlined
                            filled
                            full-width
                            class="create-content-input v-input"
                            placeholder="Write a comment.."
                          />
                          <v-icon
                            style="margin-left: -2rem; margin-top: -1.3rem"
                            >mdi-message</v-icon
                          >
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                  <div
                    style="height: 550px; overflow-x: hidden; overflow-y: auto"
                    class="comment-dialog"
                    v-else
                  >
                    <div style="margin: 0px 20px">
                      <comment type="video" v-on:back="comeBack($event)" />
                      <!-- <h1>HEllo</h1> -->
                    </div>
                  </div>
                </v-row>
                <v-row>
                  <button
                    class="closeBtn"
                    @click="
                      ($store.state.createContentStore.createContent__Video.dialog = false),
                        (showComment = false)
                    "
                  >
                    Close
                  </button>
                </v-row>
              </div>
            </v-col>
            <v-col>
              <!-- <v-avatar color="white" size="55" class="iconBtn">
              <v-icon size="24px" color="#9E9F9E">
                mdi-chevron-right</v-icon
              ></v-avatar
            > -->
            </v-col>
          </v-row>
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { TimeAgo } from "vue2-timeago";
import Media from "@dongido/vue-viaudio";
import Comment from "./comment.vue";

export default {
  name: "videoCardModal",
  components: {
    TimeAgo,
    Media,
    Comment,
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showComment: false,
      brandName: "",
      time: "",
      brandLogo: "",
      image: "",
      heading: "",
      desc: "",
      likes: "",
      comments: "",
      shares: "",
      type: "",
      power: 30,
      sec: 70,
    

    };
  },
  methods: {
    comeBack(e) {
      console.log("aaa  ", e);
      this.showComment = e;
      console.log("aaa  ", this.showComment);
    },
  },
  computed: {
    VideoDetails() {
      return this.$store.getters["createContentStore/GET_VIDEO_DETAILS"];
    },
  },
};
</script>

<style lang="scss" scoped>
/* The Overlay (background) */
// .overlay {
//   /* Height & width depends on how you want to reveal the overlay (see JS below) */
//   height: 100%;
//   width: 100%;
//   position: fixed; /* Stay in place */
//   z-index: 1; /* Sit on top */
//   right: 0;
//   top: 0;
//   left: inherit;
//   //filter: blur(2px);
//   margin: auto;
//   padding: auto;
//   background-color: rgb(0, 0, 0); /* Black fallback color */
//   background-color: rgb(120, 128, 120, 0.4); /* Black w/opacity */
//   backdrop-filter: blur(8px);
//   //overflow-x: hidden; /* Disable horizontal scroll */
//   //transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
// }
.comment-dialog {
  background-color: white;
  color: black;
  font-family: Roboto;
  // padding: 20px;
  margin-top: 0rem;
  width: 700px;
  margin-bottom: 1rem;
  border-radius: 4px;
}
.draft {
  background: rgba(49, 138, 54, 0.05);

  // background: #f1f6f4;
  border-radius: 5px;
  width: 100%;
  height: 63px;
}
.videoWrapper {
  height: 100%;
  width: 100%;
  background-color: rgb(0, 0, 0); /* Black fallback color */
  background-color: rgb(120, 128, 120, 0.4); /* Black w/opacity */
  backdrop-filter: blur(8px);
}
.create-content-dialog {
  background-color: white;
  font-family: Roboto;
  //padding: 20px;
  margin-top: 0rem;
  width: 532px;
  //max-height: 500px;
  margin-bottom: 1rem;
  border-radius: 4px;
}
.overlay-content {
  //background-color: grey;
  margin: auto;
  padding: auto;
  position: relative;
  top: 25%; /* 25% from the top */
  width: 100%; /* 100% width */
  text-align: center; /* Centered text/links */
  //margin-top: 30px; /* 30px top margin to avoid conflict with the close button on smaller screens */
}

.avatar {
  margin-right: 1rem;
  margin-left: -1rem;
}
.name {
  margin-top: 0.5rem;
}
.icon {
  //align-items: flex-end;
  justify-content: flex-end;
}

.add {
  background: #f4faf7;
  padding: auto;
  margin-top: auto;
}

.v-input input {
  max-height: 32px;
  background-color: aquamarine !important;
}
.iconBtn {
  width: 30px !important;
  font-size: 4rem;
  margin-top: 50%;
}
.closeBtn {
  background-color: #ffffff;
  width: 185px;
  margin: auto;
  height: 55px;
  border-radius: 33px;
  color: #9e9f9e;
  font-size: 18px;
  font-weight: 400;
}
</style>
